import React, { Component } from "react";
import {
  Container,
  Row,
  Col,
  CardGroup,
  Card,
  CardBody,
  Button,
  Input,
  InputGroup,
  Form,
} from "reactstrap";
import { ACCESS_TOKEN, API_BASE_URL, onlyChrRegex } from "../../../constants";
import { withRouter } from "react-router";

import nav from "../../../components/Sidebar/_nav";
import CompanyName from '../../../components/CompanyName';
import swal from "sweetalert";

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      usernameOrEmail: "",
      password: "",
      pasteAction: false,
      pasteActionPass: false,
    };

    this.onChangeusernameOrEmail = this.onChangeusernameOrEmail.bind(this);
    this.onChangepassword = this.onChangepassword.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onPaste = this.onPaste.bind(this);

    this.onPastePass = this.onPastePass.bind(this);
  }

  componentWillUnmount() {
    document.removeEventListener("contextmenu", this._handleContextMenu);
  }
  _handleContextMenu(event) {
    event.preventDefault();
  }
  setNavItems(role) {
    if (role == "ROLE_ADMIN") return nav.items2;
    else return nav.items3;
  }

  onPaste(e) {
    this.setState({
      pasteAction: true,
    });
  }

  onPastePass(e) {
    this.setState({
      pasteActionPass: true,
    });
  }

  onChangeusernameOrEmail(e) {
    if (this.state.pasteAction) {
      this.setState({
        usernameOrEmail: e.target.value.replace(onlyChrRegex, ""),
        pasteAction: false,
      });
    } else {
      this.setState({
        usernameOrEmail: e.target.value,
      });
    }
  }

  onChangepassword(e) {
    if (this.state.pasteActionPass) {
      this.setState({
        password: "",
        pasteActionPass: false,
      });
    } else {
      this.setState({
        password: e.target.value,
      });
    }
  }

  formValidate(obj) {
    if (!obj.usernameOrEmail) {
      swal("Enter username");
      return false;
    } else if (!obj.password) {
      swal("Enter Password");
      return false;
    } else {
      return true;
    }
  }

  onSubmit(e) {
    event.preventDefault();

    const obj = {
      usernameOrEmail: this.state.usernameOrEmail,
      password: this.state.password,
    };

    let status = this.formValidate(obj);
    if (!status) {
      return false;
    }
    fetch(API_BASE_URL + "/api/auth/signin", {
      method: "POST",
      body: JSON.stringify(obj),
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then(
        (response) => {
          if (response.success) {
            localStorage.setItem(ACCESS_TOKEN, response.accessToken);
            localStorage.setItem("username", response.userName);
            localStorage.setItem("access-role", response.role);
            localStorage.setItem(
              "loggedNav",
              JSON.stringify(this.setNavItems(response.role))
            );
            // this.props.handler();
            this.props.history.push("/dashboard");
          } else {
            this.setState({
              usernameOrEmail: "",
              password: "",
            });

            swal(response.msg);
          }
        },
        (error) => {
          alert(error);
        }
      );
  }

  render() {
    return (
      <div
        className="app flex-row align-items-center"
        style={{
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          height: '100vh',
          position: 'relative',
          overflow: 'hidden'
        }}
      >
        {/* Animated Background Elements */}
        <div style={{
          position: 'absolute',
          top: '10%',
          left: '10%',
          width: '120px',
          height: '120px',
          background: 'rgba(255,255,255,0.1)',
          borderRadius: '50%',
          animation: 'float 6s ease-in-out infinite'
        }}></div>
        <div style={{
          position: 'absolute',
          top: '70%',
          right: '15%',
          width: '80px',
          height: '80px',
          background: 'rgba(255,255,255,0.08)',
          borderRadius: '50%',
          animation: 'float 4s ease-in-out infinite reverse'
        }}></div>
        <div style={{
          position: 'absolute',
          bottom: '10%',
          left: '20%',
          width: '60px',
          height: '60px',
          background: 'rgba(255,255,255,0.06)',
          borderRadius: '50%',
          animation: 'float 5s ease-in-out infinite'
        }}></div>

        <Container fluid className="h-100">
          <Row className="justify-content-center align-items-center h-100">
            <Col lg="11" xl="10">
              <Card
                className="shadow-lg border-0"
                style={{
                  borderRadius: '16px',
                  overflow: 'hidden',
                  backdropFilter: 'blur(10px)',
                  background: 'rgba(255,255,255,0.95)',
                  maxHeight: '90vh'
                }}
              >
                <Row className="no-gutters h-100">
                  {/* Left Panel - Login Form */}
                  <Col md="6">
                    <CardBody
                      className="p-4"
                      style={{
                        background: 'linear-gradient(145deg, #ffffff 0%, #f8f9fc 100%)',
                        height: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center'
                      }}
                    >
                      {/* Company Branding */}
                      <div className="text-center mb-3">
                        <div style={{
                          fontSize: '1.8rem',
                          fontWeight: '800',
                          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                          WebkitBackgroundClip: 'text',
                          WebkitTextFillColor: 'transparent',
                          backgroundClip: 'text',
                          marginBottom: '0.3rem',
                          letterSpacing: '0.5px'
                        }}>
                          <CompanyName fallback="" />
                        </div>
                        <div style={{
                          fontSize: '0.95rem',
                          color: '#6c757d',
                          fontWeight: '500',
                          marginBottom: '0.2rem'
                        }}>
                          🍦 kwality wall's Ice Cream Distribution
                        </div>
                        <div style={{
                          fontSize: '0.75rem',
                          color: '#9ca3af',
                          fontStyle: 'italic'
                        }}>
                          Powered by P4Systems
                        </div>
                      </div>

                      {/* Login Section */}
                      <div className="text-center mb-3">
                        <h2 style={{
                          fontSize: '1.5rem',
                          fontWeight: '700',
                          color: '#2d3748',
                          marginBottom: '0.3rem'
                        }}>
                          Welcome Back! 👋
                        </h2>
                        <p style={{
                          color: '#718096',
                          fontSize: '0.85rem',
                          marginBottom: '1.5rem'
                        }}>
                          Sign in to manage your ice cream distribution business
                        </p>
                      </div>

                      <Form>
                        {/* Username Input */}
                        <div className="mb-3">
                          <InputGroup style={{
                            borderRadius: '10px',
                            overflow: 'hidden',
                            boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
                          }}>
                            <div className="input-group-prepend">
                              <span
                                className="input-group-text"
                                style={{
                                  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                  border: 'none',
                                  color: 'white',
                                  padding: '10px 12px'
                                }}
                              >
                                <i className="icon-user" style={{ fontSize: '1rem' }}></i>
                              </span>
                            </div>
                            <Input
                              type="text"
                              placeholder="Enter your username"
                              value={this.state.usernameOrEmail}
                              onPaste={this.onPaste}
                              onChange={this.onChangeusernameOrEmail}
                              style={{
                                border: 'none',
                                padding: '10px 12px',
                                fontSize: '0.95rem',
                                backgroundColor: '#f8f9fa'
                              }}
                            />
                          </InputGroup>
                        </div>

                        {/* Password Input */}
                        <div className="mb-3">
                          <InputGroup style={{
                            borderRadius: '10px',
                            overflow: 'hidden',
                            boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
                          }}>
                            <div className="input-group-prepend">
                              <span
                                className="input-group-text"
                                style={{
                                  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                  border: 'none',
                                  color: 'white',
                                  padding: '10px 12px'
                                }}
                              >
                                <i className="icon-lock" style={{ fontSize: '1rem' }}></i>
                              </span>
                            </div>
                            <Input
                              type="password"
                              placeholder="Enter your password"
                              maxLength="15"
                              minLength="6"
                              value={this.state.password}
                              onPaste={this.onPastePass}
                              onChange={this.onChangepassword}
                              style={{
                                border: 'none',
                                padding: '10px 12px',
                                fontSize: '0.95rem',
                                backgroundColor: '#f8f9fa'
                              }}
                            />
                          </InputGroup>
                        </div>

                        {/* Login Button */}
                        <Button
                          type="button"
                          onClick={this.onSubmit}
                          block
                          style={{
                            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                            border: 'none',
                            borderRadius: '10px',
                            padding: '10px',
                            fontSize: '1rem',
                            fontWeight: '600',
                            boxShadow: '0 4px 12px rgba(102, 126, 234, 0.4)',
                            transition: 'all 0.3s ease'
                          }}
                          onMouseOver={(e) => {
                            e.target.style.transform = 'translateY(-1px)';
                            e.target.style.boxShadow = '0 6px 16px rgba(102, 126, 234, 0.6)';
                          }}
                          onMouseOut={(e) => {
                            e.target.style.transform = 'translateY(0)';
                            e.target.style.boxShadow = '0 4px 12px rgba(102, 126, 234, 0.4)';
                          }}
                        >
                          <i className="icon-login mr-2"></i>
                          Sign In to Dashboard
                        </Button>
                      </Form>

                      {/* Features Icons */}
                      <div className="text-center mt-3">
                        <div style={{
                          fontSize: '0.75rem',
                          color: '#9ca3af',
                          marginBottom: '0.8rem'
                        }}>
                          Manage your business efficiently
                        </div>
                        <div className="d-flex justify-content-center">
                          <div className="text-center mx-2">
                            <i className="icon-graph" style={{ fontSize: '1.2rem', color: '#667eea', marginBottom: '0.3rem' }}></i>
                            <div style={{ fontSize: '0.65rem', color: '#718096' }}>Analytics</div>
                          </div>
                          <div className="text-center mx-2">
                            <i className="icon-speedometer" style={{ fontSize: '1.2rem', color: '#667eea', marginBottom: '0.3rem' }}></i>
                            <div style={{ fontSize: '0.65rem', color: '#718096' }}>Distribution</div>
                          </div>
                          <div className="text-center mx-2">
                            <i className="icon-people" style={{ fontSize: '1.2rem', color: '#667eea', marginBottom: '0.3rem' }}></i>
                            <div style={{ fontSize: '0.65rem', color: '#718096' }}>Team</div>
                          </div>
                          <div className="text-center mx-2">
                            <i className="icon-screen-smartphone" style={{ fontSize: '1.2rem', color: '#667eea', marginBottom: '0.3rem' }}></i>
                            <div style={{ fontSize: '0.65rem', color: '#718096' }}>Mobile</div>
                          </div>
                        </div>
                      </div>
                    </CardBody>
                  </Col>

                  {/* Right Panel - Branding & Visuals */}
                  <Col md="6">
                    <CardBody
                      className="text-white d-flex flex-column justify-content-center align-items-center p-4"
                      style={{
                        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                        height: '100%',
                        position: 'relative',
                        overflow: 'hidden'
                      }}
                    >
                      {/* Decorative Elements */}
                      <div style={{
                        position: 'absolute',
                        top: '-30px',
                        right: '-30px',
                        width: '120px',
                        height: '120px',
                        background: 'rgba(255,255,255,0.1)',
                        borderRadius: '50%'
                      }}></div>
                      <div style={{
                        position: 'absolute',
                        bottom: '-20px',
                        left: '-20px',
                        width: '100px',
                        height: '100px',
                        background: 'rgba(255,255,255,0.08)',
                        borderRadius: '50%'
                      }}></div>

                      {/* Main Content */}
                      <div className="text-center" style={{ zIndex: 10, position: 'relative' }}>
                        {/* Company Logo */}
                        <div className="mb-3">
                          <img
                            src={"img/favicon1.png"}
                            alt="Company Logo"
                            style={{
                              width: '80px',
                              height: '80px',
                              borderRadius: '15px',
                              boxShadow: '0 8px 25px rgba(0,0,0,0.3)',
                              marginBottom: '1rem'
                            }}
                          />
                        </div>

                        {/* Ice Cream Business Graphics */}
                        <div className="mb-3">
                          <div style={{
                            fontSize: '2.5rem',
                            marginBottom: '0.8rem'
                          }}>
                            🍦🧊🚚
                          </div>
                        </div>

                        {/* Welcome Text */}
                        <h3 style={{
                          fontSize: '1.5rem',
                          fontWeight: '700',
                          marginBottom: '0.8rem',
                          textShadow: '0 2px 8px rgba(0,0,0,0.3)'
                        }}>
                          Ice Cream Distribution Made Easy
                        </h3>

                        <p style={{
                          fontSize: '0.9rem',
                          opacity: 0.9,
                          lineHeight: '1.5',
                          marginBottom: '1.5rem'
                        }}>
                          Streamline your daily operations, track orders, manage retail shops, monitor salesmen, and handle collections all in one place.
                        </p>

                        {/* Feature Highlights */}
                        <div className="mb-3">
                          <div className="d-flex align-items-center justify-content-center mb-1" style={{ fontSize: '0.85rem' }}>
                            <i className="icon-check mr-2" style={{ color: '#48bb78', fontSize: '0.9rem' }}></i>
                            <span>Real-time Order Tracking</span>
                          </div>
                          <div className="d-flex align-items-center justify-content-center mb-1" style={{ fontSize: '0.85rem' }}>
                            <i className="icon-check mr-2" style={{ color: '#48bb78', fontSize: '0.9rem' }}></i>
                            <span>Salesman Performance Analytics</span>
                          </div>
                          <div className="d-flex align-items-center justify-content-center mb-1" style={{ fontSize: '0.85rem' }}>
                            <i className="icon-check mr-2" style={{ color: '#48bb78', fontSize: '0.9rem' }}></i>
                            <span>Automated Collection Management</span>
                          </div>
                        </div>

                        {/* P4Systems Branding */}
                        <div style={{
                          marginTop: '1.5rem',
                          padding: '0.8rem',
                          background: 'rgba(255,255,255,0.1)',
                          borderRadius: '8px',
                          backdropFilter: 'blur(10px)'
                        }}>
                          <div style={{ fontSize: '0.8rem', opacity: 0.8 }}>
                            Developed by
                          </div>
                          <div style={{
                            fontSize: '1rem',
                            fontWeight: '600',
                            letterSpacing: '0.5px'
                          }}>
                            P4Systems
                          </div>
                        </div>
                      </div>
                    </CardBody>
                  </Col>
                </Row>
              </Card>
            </Col>
          </Row>
        </Container>

        {/* CSS Animations */}
        <style jsx>{`
          @keyframes float {
            0%, 100% { transform: translateY(0px) rotate(0deg); }
            50% { transform: translateY(-15px) rotate(180deg); }
          }
          
          .input-group-text:hover {
            transform: scale(1.05);
            transition: all 0.3s ease;
          }
          
          body, html {
            overflow: hidden !important;
            height: 100vh !important;
          }
          
          .app {
            height: 100vh !important;
            overflow: hidden !important;
          }
          
          @media (max-width: 768px) {
            .card {
              margin: 0.5rem !important;
              max-height: 95vh !important;
            }
            
            body, html {
              overflow: auto !important;
            }
          }
        `}</style>
      </div>
    );
  }
}

export default withRouter(Login);



// WEBPACK FOOTER //
// ./src/views/Pages/Login/Login.js